import { Helpers, Router, API } from '../Helpers';
import ModalVideo from 'react-modal-video';
import { PhotoSwipe } from 'react-photoswipe';
import { CallToBook, NextArrow, PrevArrow, ResmarkButton, ReviewRating, ReviewsModal } from '../Shared';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Slider from "react-slick";
import ImageBoard from '../ImageBoard';
import BookingWidget from '../BookingWidget/BookingWidget';
import SimilarToursCarousel from '../SimilarToursCarousel';
import Icon from '../MysticIcon';
import _ from 'lodash';
import EmailToBook from '../Shared/EmailToBook';
import ReturnToBooking from '../Shared/ReturnToBooking';

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cart: this.props.data.cart,
            index: 0,
            photo_carousel_open: false,
            step: 1,
            video_is_open: false,
            similarTours: [],
            loadingSimilarTours: false,
            activities: '',
            totalPrice: 0,
            add_ons: this.props.data.tour.tags.data.filter(tag => tag.tag_group_name == 'Add Ons').map(tag => tag.name),
            specific_tours: this.props.data.specific_tours || false
        };

        this.closePhotoCarousel = this.closePhotoCarousel.bind(this);
        this.closeVideo = this.closeVideo.bind(this);
        this.doNothing = this.doNothing.bind(this);
        this.findCancellationPolicy = this.findCancellationPolicy.bind(this);
        this.findPhoneNumber = this.findPhoneNumber.bind(this);
        this.findReviewAvatar = this.findReviewAvatar.bind(this);
        this.findTermsConditions = this.findTermsConditions.bind(this);
        this.generateProductUrl = this.generateProductUrl.bind(this);
        this.getProductImages = this.getProductImages.bind(this);
        this.inCart = this.inCart.bind(this);
        this.isCallToBook = this.isCallToBook.bind(this);
        this.isEmailToBook = this.isEmailToBook.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.openPhotoCarousel = this.openPhotoCarousel.bind(this);
        this.openVideo = this.openVideo.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.showProductImage = this.showProductImage.bind(this);
        this.getPricingType = this.getPricingType.bind(this);
        this.isBahamasSite = this.isBahamasSite.bind(this);
        this.isMysticMountainSite = this.isMysticMountainSite.bind(this);
        this.getActivities = this.getActivities.bind(this);
        this.defaultEntityId = this.defaultEntityId.bind(this);
    }

    componentDidMount() {

        if (_.isEmpty(this.props.data.location))
            return;

        this.setState({ loadingSimilarTours: true });

        const router = Router(this.props.data.routes);
        const onResponse = {
            success: (response) => {
                // console.log("similar tours", response);

                const tours = response.data.map(tour => {
                    const price = this.props.data.env.CURRENCY + " " + Helpers.formatNoDecimalCurrency(
                        tour.price
                    );
                    // console.log("urL", this.generateProductUrl(tour));

                    return {
                        tour,
                        productUrl: this.generateProductUrl(tour),
                        isInCart: this.inCart(tour),
                        pricingType: this.getPricingType(tour),
                        price,
                        image: tour.cover_photo && tour.cover_photo.medium,

                    }
                });

                this.setState({
                    similarTours: tours,
                    loadingSimilarTours: false,
                });
            },
            error: error => console.log("error"),
            complete: () => { }
        }

        API.get(onResponse, router.url('getSimilarTours', { id: this.props.data.tour.id, domain: this.props.data.active_site.domain }));
    }

    getActivities(tags) {
        return tags.data.filter(tag => tag.tag_group_name == 'Tour Activities');
    }

    getPricingType(tour) {
        let pricingType = _.find(tour.tags.data, (_tag) => {
            return _tag.tag_group_name === "Pricing Type";
        });

        pricingType = !_.isEmpty(pricingType)
            ? pricingType.name
            : "per person";

        return _.upperCase(pricingType);
    }

    closePhotoCarousel() {
        this.setState({
            photo_carousel_open: false
        });
    };

    closeVideo() {
        this.setState({
            video_is_open: false
        });
    }

    doNothing() {
        //
    }

    findCancellationPolicy() {
        let cancellation_policy = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'cancellation_policy'; });

        if (!_.isEmpty(cancellation_policy)) {
            return cancellation_policy.value;
        }
    }

    findPhoneNumber() {
        let phone_number = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'phone_number'; });

        if (!_.isEmpty(phone_number)) {
            return phone_number.value;
        }
    }

    findReviewAvatar(review) {
        if (!_.isEmpty(review.avatar)) {
            return review.avatar;
        }

        return '/images/placeholder-avatar.jpeg';
    }

    findTermsConditions() {
        let terms_conditions = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'terms_conditions'; });

        if (!_.isEmpty(terms_conditions)) {
            return terms_conditions.value;
        }
    }

    generateProductUrl(tour) {
        const router = Router(this.props.data.routes);

        let params = {
            domain: this.props.data.active_site.domain,
            id: tour.id,
            tour_slug: tour.slug
        };

        // console.log("location", this.props.data.location);

        const { region_slug, country_slug } = this.props.data.location;

        if (_.isEmpty(region_slug) && _.isEmpty(country_slug)) {
            // console.log("no location", tour.location);
            const location = JSON.parse(tour.location)[0];
            const country = location.country.replace(/(the)/gi, '').trim().toLowerCase();
            // console.log("country", country);
            params.country_slug = country;
            return router.url('tours.show_country', params);
        }

        if (!_.isEmpty(this.props.data.location.region_slug)) {
            params.region_slug = this.props.data.location.region_slug;
            params.country_slug = this.props.data.location.country_slug;

            return this.state.specific_tours ? router.url("specific_tours.show_region", params) : router.url("tours.show_region", params);

        }

        if (!_.isEmpty(this.props.data.location.country_slug)) {
            params.country_slug = this.props.data.location.country_slug;

            return this.state.specific_tours ? router.url("specific_tours.show_country", params) : router.url("tours.show_country", params);

        }
    }

    getProductImages() {
        let product_images = [];

        _.forEach(JSON.parse(this.props.data.tour.images), (image) => {

            product_images.push({
                src: image.large,
                w: 1600,
                h: 1000
            });
        });

        //console.log(product_images);

        return product_images;
    }

    inCart() {
        let index = _.findIndex(this.state.cart.items, (_item) => { return this.props.data.tour.name == _item.name; });

        if (index > -1) {
            return true;
        }

        return false;
    }

    isCallToBook() {
        const index = _.findIndex(this.props.data.tour.tags.data, (_tag) => { return _tag.name == 'Call To Book'; });

        if (index > -1) {
            return true;
        }

        return false;
    }

    isEmailToBook() {
        const index = _.findIndex(this.props.data.tour.tags.data, (_tag) => { return _tag.name == 'Email To Book'; });

        if (index > -1) {
            return true;
        }

        return false;
    }

    nextStep(step = 1) {
        //console.log("nextStep");

        this.setState({
            step: this.state.step + step
        });
    }

    openVideo() {
        this.setState({
            video_is_open: true
        });
    }

    openPhotoCarousel() {
        this.setState({
            photo_carousel_open: true
        });
    }

    previousStep() {
        //console.log("previousStep");

        this.setState({
            step: this.state.step - 1
        });
    }

    showProductImage(index) {
        this.setState({
            index: index
        }, () => {
            this.openPhotoCarousel();
        });
    }

    isBahamasSite() {
        console.log("active site domain", this.props.data.active_site.domain);
        return this.props.data.active_site.domain.search(/bahamas/i) >= 0;
    }

    isMysticMountainSite() {
        return this.props.data.active_site.domain.search(/mystic/i) >= 0;
    }


    isExclusiveTours() {
        return this.props.data.active_site.domain.search(/exclusive/i) >= 0;
    }


    defaultEntityId() {
        const entityId = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'rm_entity_id'; })

        if (entityId) return entityId.value;
        return "";
    }

    render() {

        const { active_site, agency, agent_id, csrf_token, env, location, pickup_options, product_items, reseller_product, routes, tour, specific_tours } = this.props.data;
        const router = Router(routes);

        // console.log("tour", tour);

        const tour_images = !_.isEmpty(tour.images) ? JSON.parse(tour.images) : [];
        const terms_conditions = this.findTermsConditions();
        const cancellation_policy = this.findCancellationPolicy();
        const phone_number = this.findPhoneNumber();

        let pricingType = _.find(tour.tags.data, (_tag) => { return _tag.tag_group_name === "Pricing Type"; })
        pricingType = !_.isEmpty(pricingType) ? pricingType.name : "per person";

        // console.log("tags", this.props.data);

        const BrowseOrCart = () => (
            <div className="text-center">
                <h4 className="body-font body-text-color font-weight-bold mb-4 mt-3">Tour added to cart!</h4>
                <a href={router.url('cart', { domain: active_site.domain })} className="btn btn-rounded btn-primary white-text z-depth-0 px-6 py-3">
                    Go to cart
                </a>
                <p className="text-muted my-1">or</p>
                {
                    _.isEmpty(location) ?
                        <button type="button" className="btn btn-secondary btn-rounded z-depth-0 px-6 py-3" data-dismiss="modal" aria-label="Close">
                            <span className="font-weight-bold">Keep Browsing</span>
                        </button> :
                        <a
                            href={!this.isBahamasSite() ?
                                router.url(
                                    specific_tours ? 'specific.tours.index' : 'tours.index',
                                    {
                                        domain: active_site.domain,
                                        country_slug: location.url_params.country_slug,
                                        'region_slug?': location.url_params.region_slug || ""
                                    }
                                ) : "#"}
                            onClick={() => {
                                if (this.isBahamasSite())
                                    window.location.href = `http://${active_site.domain}/tours-in-bahamas`
                            }}
                            className="btn btn-secondary btn-rounded z-depth-0 px-6 py-3"
                        >
                            <span className="font-weight-bold">Keep Browsing</span>
                        </a>
                }
            </div>
        )



        const onAddToCart = () => BrowseOrCart()

        return (
            <div>
                <div className="position-relative overflow-hidden">
                    {
                        !_.isEmpty(location) && !this.isExclusiveTours() &&
                        <div className="container body-text-color">
                            <a
                                href={!this.isBahamasSite() ?
                                    router.url(
                                        specific_tours ? 'specific.tours.index' : 'tours.index',
                                        {
                                            domain: active_site.domain,
                                            country_slug: location.url_params.country_slug,
                                            'region_slug?': location.url_params.region_slug || ""
                                        }
                                    ) : `http://${active_site.domain}/tours-in-bahamas`}
                                className="btn my-1 p-0 primary-text"
                            >
                                <span className="font-small font-weight-bold">
                                    <i className="fa fa-chevron-left mr-2"></i>Back To Listings
                                </span>
                            </a>
                        </div>
                    }
                    <ImageBoard images={tour_images} video={tour.video} />
                </div>



                {/* <div className="flex-center position-absolute w-100 z-2">
                    {
                        !_.isEmpty(tour.video) &&
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="text-center">
                                        <ModalVideo 
                                            channel={tour.video.channel} 
                                            isOpen={this.state.video_is_open} 
                                            videoId={tour.video.id} 
                                            onClose={() => { this.closeVideo() }} 
                                        />
                                        <button 
                                            className="btn btn-flat js-modal-btn cursor-pointer" 
                                            onClick={this.openVideo}>
                                            <span className="font-larger text-shadow-1 white-text">
                                                <i className="far fa-play-circle fa-5x"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div> */}

                <div className="container mt-4">
                    <div className="row">
                        <div className="col-lg-8 col-sm-12">

                            <div className="row">
                                <div className="col">
                                    {
                                        !_.isEmpty(tour.address) && !this.isExclusiveTours() &&
                                        <div><span className="body-text-color font-smaller text-uppercase">{tour.address}</span></div>
                                    }

                                    <h4 className="body-font body-text-color font-weight-bold">
                                        {this.isExclusiveTours() ? 'Explore the Ordinary' : tour.name}
                                    </h4>

                                    {
                                        !_.isNull(tour.average_rating) &&
                                        <ReviewRating
                                            star_rating={tour.average_rating}
                                            count={tour.reviews_count}
                                        />
                                    }

                                    {!this.isExclusiveTours() && <div>

                                        <div className="d-none d-lg-block media mt-2">
                                            <div className="mr-0 align-self-center">
                                                <div className="body-text-color text-uppercase" style={{ lineHeight: 0.75, fontSize: 12 }}>Starting From</div>
                                                <div className="d-flex d-inline align-items-end">
                                                    <h3 className="mr-1 body-font font-weight-bold">{env.CURRENCY + ' ' + Helpers.formatNoDecimalCurrency(tour.price)}</h3>
                                                    <span className="body-text-color align-self-center" style={{ lineHeight: 0.75, fontSize: 12 }}>{_.upperCase(pricingType)}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            !_.isEmpty(tour.date_settings) &&
                                            !_.isEmpty(tour.date_settings.duration) &&
                                            <div className="body-text-color font-small"><i className="far fa-clock mr-1"></i><span className="font-small">{tour.date_settings.duration}</span></div>
                                        }

                                    </div>}





                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    {!this.isExclusiveTours() &&
                                        <div>
                                            <hr className="hr-dashed" />
                                            {
                                                this.isMysticMountainSite() ?
                                                    <div>
                                                        {this.getActivities(tour.tags).length > 0 &&
                                                            <div className="mb-4">
                                                                <div className="font-weight-bold mb-3 text-uppercase">Activities:</div>
                                                                <div className="small activity-list text-center d-flex" style={{ flexWrap: 'wrap' }}>
                                                                    {this.getActivities(tour.tags).map((activity, i) => (
                                                                        <span key={i} className="activity mr-2 mb-2">
                                                                            {activity.slug &&
                                                                                <Icon name={activity.slug} />
                                                                            }
                                                                            <div className="text-uppercase font-weight-bold small mt-1">{activity.name}</div>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }

                                                        {/* {this.state.add_ons.length > 0 &&
                                                            <div>
                                                                <div className="font-weight-bold mb-3 text-uppercase">Add-ons & Additional Services:</div>
                                                                <div className="small add-ons-list">
                                                                    {this.state.add_ons.map((add_on, i) => (
                                                                        <span key={i} className="mr-2 mb-1 font-weight-bold text-uppercase add-on">{add_on}</span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        } */}

                                                    </div>
                                                    :
                                                    <div>
                                                        <div className="d-none d-lg-block">
                                                            <ul className="list-inline d-flex align-items-center mb-0">
                                                                <li className="list-inline-item mr-8">
                                                                    <div className="font-weight-bold">Includes:</div>
                                                                </li>

                                                                {
                                                                    tour.inclusions.map((inclusion, key) => {

                                                                        return (
                                                                            <li key={key} className="list-inline-item mr-9">
                                                                                <div>
                                                                                    <i className={"mr-2 fa fa-lg " + inclusion.icon}></i>{inclusion.name}
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                        <div className="d-lg-none">
                                                            <div className="font-weight-bold mb-3">Includes:</div>

                                                            <div className="row">
                                                                {
                                                                    tour.inclusions.map((inclusion, key) => {

                                                                        return (
                                                                            <div key={key} className="col-4 mb-3">
                                                                                <div className="text-center">
                                                                                    <i className={"mr-2 fa fa-lg " + inclusion.icon}></i>
                                                                                    <div>
                                                                                        {inclusion.name}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                            }
                                            <hr className="hr-dashed" />
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="row pb-9">
                                <div className="col-md-10">
                                    {!this.isExclusiveTours() && <div>
                                        <h3 className="font-weight-bold body-font">
                                            Description
                                        </h3>
                                        <hr className="hr-3px hr-primary hr-short" align="left" />
                                    </div>}


                                    <div>
                                        {
                                            !_.isEmpty(tour.short_description) &&
                                            <div className="mb-3">
                                                <span className="font-weight-bold font-large" dangerouslySetInnerHTML={{ __html: tour.short_description }} />
                                            </div>
                                        }

                                        {
                                            !_.isEmpty(tour.overview) &&
                                            <div dangerouslySetInnerHTML={{ __html: tour.overview }} />
                                        }
                                    </div>
                                </div>
                            </div>

                            {this.isExclusiveTours() && <div className='mb-5'>

                                <div className="d-none d-lg-block media">
                                    <div className="mr-0 align-self-center">
                                        <div className="body-text-color text-uppercase" style={{ lineHeight: 0.75, fontSize: 12 }}>Starting From</div>
                                        <div className="d-flex d-inline align-items-end">
                                            <h3 className="mr-1 body-font font-weight-bold">{env.CURRENCY + ' ' + Helpers.formatNoDecimalCurrency(tour.price)}</h3>
                                            <span className="body-text-color align-self-center" style={{ lineHeight: 0.75, fontSize: 12 }}>{_.upperCase(pricingType)}</span>
                                        </div>
                                    </div>
                                </div>

                                {
                                    !_.isEmpty(tour.date_settings) &&
                                    !_.isEmpty(tour.date_settings.duration) &&
                                    <div className="body-text-color font-small"><i className="far fa-clock mr-1"></i><span className="font-small">{tour.date_settings.duration}</span></div>
                                }

                            </div>}

                            <div className="row pb-9">
                                <div className="col-md-11">
                                    {this.isExclusiveTours() ?
                                        <h4 className={`body-font`}>
                                            Tour Highlights
                                        </h4>
                                        :
                                        <h3 className={`body-font font-weight-bold`}>
                                            Tour Highlights
                                        </h3>
                                    }

                                    <hr className="hr-3px hr-primary hr-short" align="left" />

                                    <div dangerouslySetInnerHTML={{ __html: Helpers.toIconList(tour.highlights, 'fa fa-check primary-text mr-2') }} />
                                </div>
                            </div>

                            <div className="row pb-9">
                                <div className="col-md-11">
                                    {
                                        JSON.parse(tour.information).map((information, key) => {

                                            return (
                                                <div key={key} className="accordion mb-4" id={"tourInformationAccordion" + key} role="tablist" aria-multiselectable="true">
                                                    <div className="card border-0 bg-transparent">
                                                        <div className="p-0" role="tab">
                                                            <button className="btn btn-flat collapsed p-0 text-decoration-none" type="button" data-toggle="collapse" data-parent={"#tourInformationAccordion" + key} data-target={"#tourInformationCollapse" + key} aria-expanded="true">
                                                                {this.isExclusiveTours() ?
                                                                    <h4 className={`mb-0 body-font body-text-color`}>
                                                                        {information.name} <i className="fa fa-angle-down rotate-icon float-none ml-3"></i>
                                                                    </h4> :
                                                                    <h3 className={`mb-0 font-weight-bold body-font body-text-color`}>
                                                                        {information.name} <i className="fa fa-angle-down rotate-icon float-none ml-3"></i>
                                                                    </h3>}


                                                            </button>
                                                        </div>
                                                        <div id={"tourInformationCollapse" + key} className="collapse" role="tabpanel">
                                                            <div className="card-body p-0">
                                                                <hr className="hr-3px hr-primary hr-short" align="left" />

                                                                <div dangerouslySetInnerHTML={{ __html: Helpers.toIconList(information.content, 'fa fa-plus primary-text mr-2') }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                    <div className="accordion" id="termsConditionsAccordion" role="tablist" aria-multiselectable="true">
                                        <div className="card border-0 bg-transparent">
                                            <div className="p-0" role="tab">
                                                <button className="btn btn-flat collapsed p-0 text-decoration-none" data-toggle="collapse" data-parent="#termsConditionsAccordion" data-target="#termsConditionsCollapse" aria-expanded="true">
                                                    {this.isExclusiveTours() ?
                                                        <h4 className={`mb-0 body-font body-text-color`}>
                                                            Terms & Conditions <i className="fa fa-angle-down rotate-icon float-none ml-3"></i>
                                                        </h4> :
                                                        <h3 className={`mb-0 font-weight-bold body-font body-text-color`}>
                                                            Terms & Conditions <i className="fa fa-angle-down rotate-icon float-none ml-3"></i>
                                                        </h3>}
                                                </button>
                                            </div>
                                            <div id="termsConditionsCollapse" className="collapse" role="tabpanel">
                                                <div className="card-body p-0">
                                                    <hr className="hr-3px hr-primary hr-short" align="left" />

                                                    {
                                                        !_.isEmpty(tour.cancellation_policy) ?
                                                            <div dangerouslySetInnerHTML={{ __html: tour.cancellation_policy }} /> :
                                                            <div dangerouslySetInnerHTML={{ __html: cancellation_policy || '' }} />
                                                    }

                                                    {
                                                        !_.isEmpty(tour.terms_conditions) || !_.isEmpty(terms_conditions) &&
                                                        <button className="btn btn-flat font-weight-bold p-0" data-toggle="modal" data-target="#termsConditionsModal">See full details</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Mobile similar tours */}
                            <div className="row d-block d-lg-none mb-5" style={{ overflow: "visible" }}>
                                <div>
                                    {this.state.loadingSimilarTours ?
                                        //loader
                                        <div className="mt-3 col-12">
                                            <h3 className="body-font font-weight-bold mb-2 primary-text">You might also like...</h3>
                                            <div className="mt-4">
                                                <div
                                                    className="spinner-border primary-text"
                                                    role="status"
                                                ></div>
                                            </div>
                                        </div>
                                        :
                                        (!_.isEmpty(this.state.similarTours) &&
                                            <SimilarToursCarousel
                                                tours={this.state.similarTours}
                                                sliderSettings={{
                                                    centerMode: true,
                                                    centerPadding: "30px",
                                                    arrows: false,
                                                }}
                                                // sliderBorder={false}
                                                headerClass="primary-text px-3"
                                                containerMargin="mt-3"
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            {/* Google Map */}
                            {!this.isExclusiveTours() && <div className="row pb-9">
                                <div className="col-md-11">
                                    <h3 className="font-weight-bold body-font">
                                        Location
                                    </h3>

                                    <div className="mb-1">{tour.address}</div>

                                    <iframe
                                        width="100%"
                                        height="450"
                                        style={{ "border": 0 }}
                                        loading="lazy"
                                        src={`https://www.google.com/maps/embed/v1/place?key=${env.GOOGLE_MAP_API_KEY}&q=${tour.address}`}
                                    />
                                </div>
                            </div>}



                            {
                                !_.isNull(tour.average_rating) &&
                                <div className="row pb-9">
                                    <div className="col-md-11">
                                        <ul className="list-inline d-flex align-items-end">
                                            <li className="list-inline-item h3 body-font font-weight-bold mb-0 mr-3">Reviews</li>
                                            <li className="list-inline-item">
                                                <ReviewRating
                                                    star_rating={tour.average_rating}
                                                    count={tour.reviews_count}
                                                />
                                            </li>
                                        </ul>

                                        <hr className="hr-3px hr-primary hr-short mb-5" align="left" />

                                        {
                                            _.take(tour.reviews.data, 5).map((review, key) => {

                                                return (
                                                    <div key={key} className="mb-5">
                                                        <div className="media mb-2">
                                                            <div className="mr-2 align-self-center">
                                                                <img className="avatar tiny-avatar border-3p border-white border-solid" src={this.findReviewAvatar(review)} />
                                                            </div>
                                                            <div className="media-body align-self-center">
                                                                <div className="font-weight-bold">{review.author}</div>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 mb-lg-4">
                                                            {review.comment}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }

                                        <ReviewsModal tour={tour} />
                                    </div>
                                </div>
                            }

                            <div id="termsConditionsModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
                                <div className="modal-dialog modal-xl">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h2 className="modal-title mb-0 body-text-color body-font">Terms & Conditions</h2>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true"><i className="fa fa-lg fa-times"></i></span>
                                            </button>
                                        </div>
                                        <div className="modal-body max-viewport-80 overflow-y-auto">
                                            <div className="row">
                                                <div className="col-12 max-viewport-65 overflow-y-auto">
                                                    {
                                                        !_.isEmpty(tour.terms_conditions) ?
                                                            <div dangerouslySetInnerHTML={{ __html: tour.terms_conditions }} /> :
                                                            <div dangerouslySetInnerHTML={{ __html: terms_conditions || '' }} />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 d-none d-lg-block">

                            <div className="row">
                                <div className="col-12">

                                    {
                                        (
                                            this.props.data.on_property &&
                                            <div className="border-primary" style={{ borderLeft: '1px solid' }}>
                                                <div className="px-3">
                                                    <h4 className="body-font primary-text-color font-weight-bold">Book Now</h4>
                                                    <p>Contact or Visit Your Activities Desk Representative For More Information.</p>

                                                    <div className='mt-3'>
                                                        <a className="d-block primary-text font-weight-bold" href={`mailto:${active_site.email}`}>{active_site.email}</a>
                                                        <a className="d-block primary-text font-weight-bold" href={`tel:2427887789`}>242-788-7789</a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        ||
                                        (
                                            !specific_tours && this.isCallToBook() &&
                                            <div>
                                                <CallToBook
                                                    phone_number={phone_number}
                                                    siteLabel={active_site.site_name}
                                                />
                                                <p className="text-muted py-1">
                                                    * Price varies based on pickup location
                                                </p>
                                            </div>
                                        ) || (

                                            !specific_tours && this.isEmailToBook() &&
                                            <EmailToBook active_site={active_site} />
                                        ) || (
                                            !specific_tours &&
                                            <div className="">
                                                {
                                                    !_.isEmpty(agency) ?
                                                        <div>
                                                            <ResmarkButton
                                                                active_site={active_site}
                                                                agency={agency}
                                                                agent_id={agent_id}
                                                                className="btn btn-rounded btn-primary white-text z-depth-0 px-6 py-3 font-weight-bold"
                                                                router={router}
                                                                reseller_product={reseller_product}
                                                            />
                                                        </div>

                                                        :


                                                        (this.isMysticMountainSite() ?

                                                            <div>
                                                                <rm-cart-button
                                                                    product-code={tour.product_code}
                                                                    entity-id={this.defaultEntityId()}
                                                                    price-code="Default"
                                                                    button-label="Book Now"
                                                                    class={"btn btn-rounded btn-primary white-text z-depth-0 px-6 py-3 font-weight-bold"}>
                                                                </rm-cart-button>
                                                            </div>

                                                            :

                                                            <div>
                                                                {
                                                                    this.inCart() ?
                                                                        <div className="d-flex justify-content-end">
                                                                            <a href={router.url('cart', { domain: active_site.domain })} className="btn btn-rounded btn-primary white-text z-depth-0 px-6 py-3">
                                                                                <i className="fa fa-check mr-2"></i>In Cart
                                                                            </a>
                                                                        </div>
                                                                        :
                                                                        <div className="booking-widget-container pb-2 border-primary" style={{ borderLeft: "1px solid" }}>
                                                                            <BookingWidget
                                                                                {...this.props.data}
                                                                                RenderOnAddedToCart={onAddToCart}
                                                                                redirect={this.isExclusiveTours()}
                                                                                pickupLocationLabel={
                                                                                    this.isBahamasSite() ?
                                                                                        "Which resort are you staying at?" :
                                                                                        "Where can we pick you up?"
                                                                                }
                                                                                onPriceChange={price => this.setState({ totalPrice: price })}
                                                                            />
                                                                        </div>
                                                                }
                                                            </div>)
                                                }
                                            </div>
                                        ) || (
                                            specific_tours &&
                                            <div className="border-primary" style={{ borderLeft: '1px solid' }}>
                                                <div className="px-3">
                                                    <h4 className="body-font primary-text-color font-weight-bold">Book Now</h4>
                                                    <p>Contact or Visit Your Tour Desk Representative For More Information.</p>

                                                    {/* <div className='mt-3'>
                                                        <a className="d-block primary-text font-weight-bold" href={`mailto:${active_site.email}`}>{ active_site.email }</a>
                                                        <a className="d-block primary-text font-weight-bold" href={`tel:${phone_number}`}>{phone_number}</a>
                                                    </div> */}
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        !specific_tours &&
                                        <ReturnToBooking
                                            startingPrice={tour.price}
                                            totalPrice={this.state.totalPrice}
                                            pricingType={pricingType}
                                            currency={env.CURRENCY}
                                            isInCart={this.inCart()}
                                            title={tour.name}
                                            settings={this.props.data.active_site.settings.data}
                                        />
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    {this.state.loadingSimilarTours ?
                                        //loader
                                        <div className="mt-5">
                                            <h3 className="body-font font-weight-bold mb-2">You might also like...</h3>
                                            <div className="mt-4">
                                                <div
                                                    className="spinner-border primary-text"
                                                    role="status"
                                                ></div>
                                            </div>
                                        </div>
                                        :
                                        (!_.isEmpty(this.state.similarTours) &&
                                            <SimilarToursCarousel tours={this.state.similarTours} specific_tours={specific_tours} />
                                        )
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="d-lg-none topbar position-fixed sticky-top z-999">
                    <div className="container-fluid white fixed-bottom border-top">
                        <div className="row py-2">
                            <div className="col-auto pr-0 d-flex align-items-center">
                                <div className="media">
                                    <div className="mr-2 align-self-center">
                                        <div className="body-text-color text-uppercase" style={{ lineHeight: 0.75, fontSize: 12 }}>Starting From</div>
                                        <div className="d-inline align-items-end">
                                            <h3 className="mr-1 mb-0 body-font font-weight-bold">{env.CURRENCY + Helpers.formatNoDecimalCurrency(tour.price)}</h3>
                                            <span className="body-text-color pb-2" style={{ fontSize: 12 }}>{_.upperCase(pricingType)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col pl-0 d-flex align-items-center">
                                {
                                    (
                                        this.props.data.on_property &&
                                        <div className="border-primary" style={{ borderLeft: '1px solid' }}>
                                            <div className="px-3 small">
                                                <p className="mb-0">Contact or Visit Your Activities Desk Representative.</p>

                                                <div className='mt-0'>
                                                    <a className="d-block primary-text font-weight-bold" href={`mailto:${active_site.email}`}>{active_site.email}</a>
                                                    <a className="d-block primary-text font-weight-bold" href={`tel:2427887789`}>242-788-7789</a>
                                                </div>
                                            </div>
                                        </div>
                                    ) || (
                                        !specific_tours && this.isCallToBook() &&
                                        <CallToBook phone_number={phone_number} />
                                    ) || (
                                        !specific_tours && this.isEmailToBook() &&
                                        <EmailToBook active_site={active_site} />
                                    ) || (
                                        !specific_tours &&
                                        <div className="w-100">
                                            {
                                                this.inCart() ?
                                                    <a href={router.url('cart', { domain: active_site.domain })} className="btn btn-rounded btn-primary btn-block white-text z-depth-0 px-6 py-3">
                                                        <i className="fa fa-check mr-2"></i>In Cart
                                                    </a> :
                                                    <div>
                                                        {
                                                            !_.isEmpty(agency) ?
                                                                <div>
                                                                    <ResmarkButton
                                                                        active_site={active_site}
                                                                        agency={agency}
                                                                        agent_id={agent_id}
                                                                        className="btn btn-rounded btn-primary white-text z-depth-0 px-6 py-3 font-weight-bold"
                                                                        router={router}
                                                                        reseller_product={reseller_product}
                                                                    />
                                                                </div> :
                                                                this.isMysticMountainSite() ?

                                                                    <div>
                                                                        <rm-cart-button
                                                                            product-code={tour.product_code}
                                                                            entity-id={this.defaultEntityId()}
                                                                            price-code="Default"
                                                                            button-label="Book Now"
                                                                            class={"btn btn-rounded btn-primary white-text z-depth-0 px-6 py-3 font-weight-bold"}>
                                                                        </rm-cart-button>
                                                                    </div>

                                                                    :
                                                                    (
                                                                        this.props.data.on_property && (
                                                                            <p className="small primary-text font-weight-bold">
                                                                                Contact or Visit Your Activities Desk Representative For More Information.
                                                                            </p>
                                                                        ) || (
                                                                            <button
                                                                                className="btn btn-rounded btn-primary btn-block white-text z-depth-0 px-6 py-2 font-weight-bold"
                                                                                data-toggle="modal"
                                                                                data-target="#bookingWidgetModal">
                                                                                Book Now
                                                                            </button>
                                                                        )
                                                                    )

                                                        }
                                                    </div>
                                            }
                                        </div>
                                    ) || (
                                        specific_tours &&
                                        <div className="border-primary" style={{ borderLeft: '1px solid' }}>
                                            <div className="px-3">
                                                <h4 className="body-font primary-text-color font-weight-bold">Book Now</h4>
                                                <p>Contact or Visit Your Tour Desk Representative For More Information.</p>

                                                {/* <div className='mt-3'>
                                                    <a className="d-block primary-text font-weight-bold" href={`mailto:${active_site.email}`}>{ active_site.email }</a>
                                                    <a className="d-block primary-text font-weight-bold" href={`tel:${phone_number}`}>{phone_number}</a>
                                                </div>*/}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>


                {/* booking widget modal */}
                <div className="modal fade" id="bookingWidgetModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content position-relative">
                            <div className="modal-header border-none position-absolute z-3" style={{ right: "10px" }}>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body pt-5">
                                <BookingWidget {...this.props.data} RenderOnAddedToCart={onAddToCart} redirect={this.isExclusiveTours()} />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

if (document.getElementById('toursShow')) {

    const element = document.getElementById('toursShow');
    const data = Object.assign({}, element.dataset);

    //console.log(data.data);

    ReactDOM.render(<App data={JSON.parse(data.data)} />, document.getElementById('toursShow'));
}



// WEBPACK FOOTER //
// ./resources/js/components/ToursShow/App.js